var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 19.25V17.4167C14.6667 16.4442 14.2804 15.5116 13.5928 14.8239C12.9052 14.1363 11.9725 13.75 11.0001 13.75H4.58342C3.61095 13.75 2.67832 14.1363 1.99069 14.8239C1.30306 15.5116 0.916748 16.4442 0.916748 17.4167V19.25M16.5001 7.33333L21.0834 11.9167M21.0834 7.33333L16.5001 11.9167M11.4584 6.41667C11.4584 8.44171 9.81679 10.0833 7.79175 10.0833C5.7667 10.0833 4.12508 8.44171 4.12508 6.41667C4.12508 4.39162 5.7667 2.75 7.79175 2.75C9.81679 2.75 11.4584 4.39162 11.4584 6.41667Z",
    stroke: "#E66666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserX);
export default __webpack_public_path__ + "static/media/user-x.952124395a8231d28d5a5e60a0697ac4.svg";
export { ForwardRef as ReactComponent };